import { SCREEN_H, SCREEN_W } from "../shared/screen";
import type { SuperDef } from "../sim";

/**
 * «Шквал» в 3D до настоящей заставки (Джон 04.11.2026, 23:22: «враг включает ярость, и я просто замираю… непонятно, что
 * сейчас вообще была она активирована, где кино?»): камера наезжает на пару, на финальном ударе — ещё ближе, края
 * кадра темнеют, жертва вздрагивает на каждом ударе. Всё — от кадра заставки (онлайн у обоих одинаково).
 */
const SERIES_ZOOM = 1.7;
const FINALE_ZOOM = 2.1;
const EASE_FRAMES = 10;

const ease = (u: number): number => (u <= 0 ? 0 : u >= 1 ? 1 : u * u * (3 - 2 * u));

/** Наезд камеры на кадре заставки: 1 — как в бою. */
export function cinematicZoom(move: SuperDef | null, frame: number): number {
  if (!move) return 1;
  const finale = frame >= move.finale.frame - 10 && frame <= move.finale.frame + 12;
  const target = finale ? FINALE_ZOOM : SERIES_ZOOM;
  const into = ease(frame / EASE_FRAMES);
  const out = ease((move.length - frame) / EASE_FRAMES);
  return 1 + (target - 1) * Math.min(into, out);
}

/** Вздрагивание жертвы: на каждом ударе серии — рывок головы и корпуса, гаснет за несколько кадров. */
export function superFlinch(move: SuperDef, frame: number): number {
  const last = [...move.hits, move.finale].reduce((at, hit) => (hit.frame <= frame ? hit.frame : at), -999);
  return Math.exp(-(frame - last) / 5);
}

/** Тёмные края кадра: сила 0..1. */
export function drawVignette(context: CanvasRenderingContext2D, strength: number): void {
  const gradient = context.createRadialGradient(
    SCREEN_W / 2,
    SCREEN_H / 2,
    SCREEN_H * 0.3,
    SCREEN_W / 2,
    SCREEN_H / 2,
    SCREEN_W * 0.62,
  );
  gradient.addColorStop(0, "rgba(0,0,0,0)");
  gradient.addColorStop(1, `rgba(0,0,0,${(0.75 * strength).toFixed(3)})`);
  context.fillStyle = gradient;
  context.fillRect(0, 0, SCREEN_W, SCREEN_H);
}
